export const translations = {
  en: {
    nav: {
      services: "Services",
      about: "About",
      whyUs: "Why Us",
      process: "Process",
      contact: "Contact",
    },
    hero: {
      headline: "Reliable IT Solutions for Modern Businesses",
      subheadline: "We build, secure, and scale your digital infrastructure.",
      cta1: "Get a Consultation",
      cta2: "Contact Us",
    },
    services: {
      overline: "What We Do",
      title: "Our Services",
      items: [
        {
          title: "IT Infrastructure",
          desc: "Design and deploy robust, scalable IT infrastructure that keeps your operations running without interruption.",
        },
        {
          title: "Cloud Solutions",
          desc: "Migrate and manage your workloads in the cloud with optimized cost, performance, and reliability.",
        },
        {
          title: "Cybersecurity",
          desc: "Protect your business with enterprise-grade security measures, monitoring, and incident response.",
        },
        {
          title: "Software Development",
          desc: "Custom software built to your specifications — from internal tools to client-facing platforms.",
        },
        {
          title: "IT Support & Maintenance",
          desc: "Proactive monitoring and rapid response to keep your systems healthy and your team productive.",
        },
      ],
    },
    about: {
      overline: "About ETRADE",
      title: "Your Trusted IT Partner",
      description:
        "ETRADE d.o.o. is a trusted IT partner delivering reliable, scalable, and secure solutions for businesses of all sizes. We combine deep technical expertise with a commitment to long-term partnerships.",
      points: ["Years of Experience", "Proven Reliability", "Custom Solutions"],
    },
    whyUs: {
      overline: "Why Choose Us",
      title: "Built Different",
      items: [
        { title: "Fast Response", desc: "Rapid reaction times when you need us most." },
        { title: "Tailored Solutions", desc: "Every solution is designed specifically for your business needs." },
        { title: "High Security", desc: "Enterprise-grade security standards across all our services." },
        { title: "Expert Team", desc: "Experienced professionals with deep domain knowledge." },
        { title: "24/7 Support", desc: "Round-the-clock monitoring and support for peace of mind." },
        { title: "Long-term Partnership", desc: "We grow with your business, not just deliver and leave." },
      ],
    },
    process: {
      overline: "How We Work",
      title: "Our Process",
      steps: [
        { title: "Consultation", desc: "We listen to your challenges and goals to understand your unique needs." },
        { title: "Planning", desc: "We design a tailored roadmap with clear milestones and deliverables." },
        { title: "Implementation", desc: "Our team executes the plan with precision and transparency." },
        { title: "Support", desc: "Ongoing monitoring, maintenance, and optimization to ensure lasting success." },
      ],
    },
    cta: {
      title: "Let's build your IT infrastructure",
      subtitle: "Ready to transform your business with reliable IT solutions?",
      button: "Contact Us Today",
    },
    contact: {
      overline: "Get in Touch",
      title: "Contact Us",
      address: "Stjenkova ulica 51, Sempeter pri Gorici, Slovenia",
      phone: "+386 5 393 9011",
      email: "etrade@siol.net",
    },
    footer: {
      rights: "All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
    },
  },
  sl: {
    nav: {
      services: "Storitve",
      about: "O nas",
      whyUs: "Zakaj mi",
      process: "Proces",
      contact: "Kontakt",
    },
    hero: {
      headline: "Zanesljive IT resitve za sodobna podjetja",
      subheadline: "Gradimo, varujemo in razsirjamo vaso digitalno infrastrukturo.",
      cta1: "Pridobite posvet",
      cta2: "Kontaktirajte nas",
    },
    services: {
      overline: "Kaj ponujamo",
      title: "Nase storitve",
      items: [
        {
          title: "IT infrastruktura",
          desc: "Nacrtujemo in postavimo zanesljivo, razsirljivo IT infrastrukturo, ki zagotavlja nemoteno poslovanje.",
        },
        {
          title: "Oblacne resitve",
          desc: "Selitev in upravljanje vasih delovnih obremenitev v oblaku z optimizirano ceno in zanesljivostjo.",
        },
        {
          title: "Kibernetska varnost",
          desc: "Zascitite svoje podjetje z varnostnimi ukrepi poslovnega razreda in nadzorom.",
        },
        {
          title: "Razvoj programske opreme",
          desc: "Programska oprema po meri — od notranjih orodij do platform za stranke.",
        },
        {
          title: "IT podpora in vzdrzevanje",
          desc: "Proaktivno spremljanje in hiter odziv za zdrave sisteme in produktivno ekipo.",
        },
      ],
    },
    about: {
      overline: "O podjetju ETRADE",
      title: "Vas zaupanja vreden IT partner",
      description:
        "ETRADE d.o.o. je zaupanja vreden IT partner, ki zagotavlja zanesljive, razsirljive in varne resitve za podjetja vseh velikosti. Zdruzujemo globoko tehnicno znanje z zavezanostjo dolgorocnim partnerstvom.",
      points: ["Dolgoletne izkusnje", "Dokazana zanesljivost", "Resitve po meri"],
    },
    whyUs: {
      overline: "Zakaj izbrati nas",
      title: "Drugacni smo",
      items: [
        { title: "Hiter odziv", desc: "Hitri odzivni casi, ko nas najbolj potrebujete." },
        { title: "Prilagojene resitve", desc: "Vsaka resitev je zasnovana posebej za vase poslovne potrebe." },
        { title: "Visoka varnost", desc: "Varnostni standardi poslovnega razreda pri vseh nasih storitvah." },
        { title: "Izkusena ekipa", desc: "Izkuseni strokovnjaki z globokim znanjem." },
        { title: "Podpora 24/7", desc: "Neprekinjeno spremljanje in podpora za mir duha." },
        { title: "Dolgorocno partnerstvo", desc: "Rastemo z vasim podjetjem, ne samo dostavimo in odidemo." },
      ],
    },
    process: {
      overline: "Kako delamo",
      title: "Nas proces",
      steps: [
        { title: "Posvetovanje", desc: "Prisluhnemo vasim izzivom in ciljem, da razumemo vase potrebe." },
        { title: "Nacrtovanje", desc: "Oblikujemo prilagojen nacrtu z jasnimi mejniki in rezultati." },
        { title: "Izvedba", desc: "Nasa ekipa izvede nacrt z natancnostjo in transparentnostjo." },
        { title: "Podpora", desc: "Stalno spremljanje, vzdrzevanje in optimizacija za trajen uspeh." },
      ],
    },
    cta: {
      title: "Zgradimo vaso IT infrastrukturo",
      subtitle: "Ste pripravljeni preoblikovati svoje podjetje z zanesljivimi IT resitvami?",
      button: "Kontaktirajte nas danes",
    },
    contact: {
      overline: "Stopite v stik",
      title: "Kontakt",
      address: "Stjenkova ulica 51, Sempeter pri Gorici, Slovenija",
      phone: "+386 5 393 9011",
      email: "etrade@siol.net",
    },
    footer: {
      rights: "Vse pravice pridrzane.",
      privacy: "Politika zasebnosti",
      terms: "Pogoji uporabe",
    },
  },
};
